
export default [
  {
    path: '/admin/coa-mappings',
    name: 'coa-mapping',
    meta: { requiresAuth: true },
    component: () => import('@/pages/accounting/coa-mapping')
  }
]
